import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    dialog: false,
    asset_label_dialog: false,
    dialog_filter: false,
    asset_label_filter: false,
    loading: false,
    users: [],
    unassigned_users: [],
    selected_owner_id: null,
    asset_labels: [],
    sync_response: [],
    show_sync_modal: false,
    cid_users: [],
    asset_label_list: [],
    stats: [],
    user: {},
    asset_label: {},
    order_column: 'name',
    order_type: 'asc',
    page: 1,
    page_size: 10,
    filter: {}
  },

  mutations: {
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setAssetLabelDialog(state, payload) {
      state.asset_label_dialog = payload
    },
    setDialogFilter(state, payload) {
       state.dialog_filter = payload
    },
    setAssetLabelFilter(state, payload) {
       state.asset_label_filter = payload
    },
    setFilter(state, payload) {
      state.filter = payload
    },
    setUsers(state, payload) {
      state.users = payload
    },
    setSyncResponse(state, payload) {
      state.sync_response = payload
    },
    setShowSyncModal(state, payload) {
      state.show_sync_modal = payload
    },
    setStats(state, payload) {
      state.stats = payload
    },
    setSelectedUser(state, payload) {
      state.user = payload
    },
    setSelectedAssetLabel(state, payload) {
      state.asset_label = payload
    },
    setCidUsers(state, payload) {
      state.cid_users = payload
    },
    setUnassignedUsers(state, payload) {
        state.unassigned_users = payload
    },
    setSelectedOwner(state, payload) {
        state.selected_owner_id = payload
    },
    setAssetLabelList(state, payload) {
        state.asset_label_list = payload
    },
    setAssetLabels(state, payload) {
      state.asset_labels = payload
    },
    setClientAssetLabels(state, payload) {
      state.user.clients = payload
    },
  },

  actions: {
    read({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/youtube/user', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...state.filter
          }
        })
        .then(r => {
          commit('setUsers',r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    insert({ commit, dispatch, state }) {
      axios.admin
          .post('cms/youtube/user', {
              user_id: state.user.user_id,
              name: state.user.name,
              email: state.user.email,
              active: state.user.active,
              asset_label_id: state.user.asset_label_id,
              clients: state.user.clients
          })
          .then(() => {
            commit('setDialog', false)
            commit('setSelectedUser', {})
            dispatch('read')
          })
    },
    update({ commit, dispatch, state }, id) {
      axios.admin
          .put('cms/youtube/user/' + id, {
            user_id: state.user.user_id,
            name: state.user.name,
            email: state.user.email,
            active: state.user.active,
            asset_label_id: state.user.asset_label_id,
            clients: state.user.clients
          })
          .then(() => {
            commit('setDialog', false)
            commit('setSelectedUser', {})
            dispatch('read')
          })
    },
    readCidUsers({ state, commit }) {
          commit('setLoading', true)
          axios.admin
              .get('cms/youtube/user/service/1')
              .then(r => {
                  commit('setCidUsers', r.data.data)
                  commit('setLoading', false)
              })
              .catch(() => {
                  commit('setLoading', false)
              })
    },
    readUnassignedUsers({ state, commit }) {
        commit('setLoading', true)
        axios.admin
            .get('cms/youtube/user/unassigned')
            .then(r => {
                commit('setUnassignedUsers', r.data.data)
                commit('setLoading', false)
            })
            .catch(() => {
                commit('setLoading', false)
            })
    },
    readAssetLabels({ state, commit }) {
          commit('setLoading', true)
          axios.admin
              .get('cms/youtube/user/assetlabel')
              .then(r => {
                  commit('setAssetLabels', r.data.data)
                  commit('setLoading', false)
              })
              .catch(() => {
                  commit('setLoading', false)
              })
    },
    // createAssetLabel({ commit, dispatch, state }) {
    //     axios.admin
    //         .post('cms/youtube/asset-label', {
    //             name: state.asset_label.name,
    //         })
    //         .then(() => {
    //             commit('setAssetLabelDialog', false)
    //             commit('setSelectedAssetLabel', {})
    //             dispatch('readAssetLabels')
    //         })
    //         .catch(() => {
    //             commit('setLoading', false)
    //         })
    // },
    assignLabelOwner({ commit, dispatch, state }, payload) {
        const { user_id, label_id } = payload
        axios.admin
            .post('cms/youtube/asset-labels/assign-owner' , {
                user_id: user_id,
                label_id: label_id,
            })
            .then(() => {
                commit('setAssetLabelDialog', false)
                commit('setSelectedAssetLabel', {})
                dispatch('readAssetLabels')
            })
    },
    listAssetLabels({ commit, state }) {
        commit('setLoading', true)
        axios.admin
            .get('cms/youtube/asset-labels', {
                params: {
                    page: state.page,
                    page_size: state.page_size,
                    order_column: state.order_column,
                    order_type: state.order_type,
                    ...state.filter
                }
            })
            .then(r => {
                commit('setAssetLabelList',r.data.data)
                commit('setLoading', false)
            })
            .catch(() => {
                commit('setLoading', false)
            })
    },
    syncAssetLabels({ dispatch, commit }) {
        commit('setLoading', true)
        axios.admin
            .get('cms/youtube/asset-labels/sync')
            .then(r => {
                commit('setLoading', false)
                commit('setSyncResponse', r.data)
                commit('setShowSyncModal', true)
                dispatch('readAssetLabels')
            })
            .catch(() => {
                commit('setLoading', false)
            })
    },
    assetLabelsStats({ commit }) {
        commit('setLoading', true)
        axios.admin
            .get('cms/youtube/asset-labels/stats')
            .then(r => {
                commit('setStats', r.data.data)
                commit('setLoading', false)
            })
            .catch(() => {
                commit('setLoading', false)
            })
    },
  },
}
